export default "__VITE_ASSET__CB10WmX___"